export default __webpack_public_path__ + "static/media/GeoLocation.d75a65a5.png";